function getStats(profileSection) {
    let tabs = 0;
    let fields = 0;

    if (profileSection) {
        tabs = profileSection.tabs || 0;
        fields = profileSection.fields || 0;
    }

    return {
        tabs,
        fields,
    };
}

export function Profile(data) {
    const { id, name, profilePosts, stat } = data;

    const { candidate, employee, candidate_short } = stat;

    return {
        id,
        name,
        positions: profilePosts.map((p) => p.post_code),
        stats: {
            employee: getStats(employee),
            candidate: getStats(candidate),
            shortCandidate: getStats(candidate_short),
        },
    };
}
